class Scrollspy {
  constructor(onSectionsUpdate) {
    this.onSectionsUpdate = onSectionsUpdate;
    this.init();
    this.sections = [];
    this.observer = null;
  }

  init() {
    if (!document.querySelector(".startpage")) return;

    const scrollSpyTitles = document.querySelectorAll(".scrollspy-title");
    const scrollspyList = document.querySelector(".scrollspy-list");

    scrollspyList.innerHTML = "";

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelectorAll(".scrollspy-list li a").forEach((el) => {
            el.classList.remove("active");
          });
          const activeLink = document.querySelector(`.scrollspy-list .${entry.target.id}`);
          if (activeLink) {
            activeLink.classList.add("active");
          }
        }
      });
    }, {
      threshold: 0.5
    });

    scrollSpyTitles.forEach((item, i) => {
      const wrapper = item.closest(".scrollspy-container-wrapper");
      if (!wrapper) return;

      const li = document.createElement("li");
      const a = document.createElement("a");

      const sectionId = `section-${i + 1}`;
      wrapper.id = sectionId;

      a.href = `#${sectionId}`;
      a.innerHTML = i + 1;
      a.classList.add(sectionId);
      a.dataset.hover = item.innerHTML || "";

      li.appendChild(a);
      scrollspyList.appendChild(li);
      this.observer.observe(wrapper);
    });

    document.querySelectorAll(".scrollspy-list a").forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = anchor.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);

        window.scrollTo({
          top: targetSection.offsetTop,
          behavior: 'smooth'
        });
      });
    });
  }
}

export default Scrollspy;




